import { Button, Tooltip } from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { useBoundStore } from "useStore";
import { ExportProductMaster } from "./utils/ExportProductMaster";
import { useState } from "react";
import useExportProductMasterData from "../Queries/ExportProductMasterData";

export default function ExportData({ channelKeys }) {
  const [loading, setLoading] = useState(false);

  const selectedOwner = useBoundStore(
    (state) => state.productMasterStSelectedOwners
  );

  const { data } = useExportProductMasterData();

  const handleExport = async () => {
    setLoading(true);

    const rows = data.data;

    await ExportProductMaster.ExportSKUs(rows, channelKeys);
    setLoading(false);
  };

  const isDisabled = selectedOwner.length === 0;

  return (
    <Tooltip title="Exportar" placement="bottom" arrow>
      <span>
        <Button
          variant="contained"
          disabled={isDisabled}
          sx={{
            backgroundColor: "#354887",
            "&:hover": {
              backgroundColor: "#354887",
            },
            height: "45px",
            width: "30.5px",
            textTransform: "uppercase",
            padding: 0,
          }}
          onClick={handleExport}
        >
          <FileDownloadOutlinedIcon
            sx={{
              width: 30,
              height: 30,
            }}
          />
        </Button>
      </span>
    </Tooltip>
  );
}
